import { gql } from '@apollo/client';
import Fragments from './fragments';

export const GENERIC_ENTITY_FLOW_LIST_QUERY = gql`
  query genericEntityFlows($entityContext: String, $pager: PagerInputNew, $filters: GenericEntityFlowFilterInput) {
    genericEntityFlows(entityContext: $entityContext, pager: $pager, filters: $filters) {
      total
      values {
        ...genericEntityFlowItem
      }
    }
  }
  ${Fragments.genericEntityFlowItem}
`;

export const GENERIC_ENTITY_FLOW_QUERY = gql`
  query genericEntityFlow($flowId: ID!) {
    genericEntityFlow(flowId: $flowId) {
      ...genericEntityFlowItem
    }
  }
  ${Fragments.genericEntityFlowItem}
`;

export const GENERIC_ENTITY_BUSINESS_STATES_QUERY = gql`
  query genericEntityBusinessStates {
    genericEntityBusinessStates {
      ...genericEntityBusinessState
    }
  }
  ${Fragments.generciEntityBusinessState}
`;

export const GENERIC_ENTITY_FLOW_TRANSITIONS_QUERY = gql`
  query genericEntityFlowTransitions($flowId: ID!) {
    genericEntityFlowTransitions(flowId: $flowId) {
      transitionId
      siteId
      flowId
      initialStateId
      finalStateId
      allowedForAllUserGroups
      fourEyesPrinciple
      requestBusinessMomentOnChange
      requestReasonOnChange
      saveHistory
      userGroups {
        flowId
        groupId
        siteId
        transitionId
        allowed
      }
    }
  }
`;
